export default "__VITE_ASSET__bpGVMub6__"